<template>
	<div class="modal" :class="{'is-active': display}">
		<div class="modal-background" @click="$emit('close')"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<h5 class="modal-card-title title is-5">
					{{ translations.title }}
				</h5>
				<button v-if="showClose" class="delete" aria-label="close" @click="$emit('close')"></button>
			</header>
			<section class="modal-card-body is-danger">
				<flashes :alerts="alerts.data" v-if="alerts && alerts.action === 'modal'"></flashes>
				<p v-html="translations.question"></p>
			</section>
			<section class="modal-card-foot">
				<div class="columns column is-fullwidth">
					<div class="column is-half">
						<button class="button is-fullwidth" @click="$emit('close')">{{ translations.cancel }}</button>
					</div>
					<div class="column is-half">
						<button class="button is-fullwidth is-success" @click="$emit('confirm')">{{ translations.confirm }}</button>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'modal-delete',
		props: {
			display: Boolean,
			translations: Object,
			loading: Boolean,
			showClose: {
				type: Boolean,
				default: true
			},
			alerts: Object,
		},
	}
</script>
